import { Box } from '@mui/material';
import React from 'react';

// While the viewbox of the icon is 30x30, the icon size is scaled to
// 28x28 by default, which results in scaling the whole image and the
// strokes a bit.
const rootSx = (theme) => ({
  width: '28px',
  height: '28px',
  stroke: theme.tokens.marketplaceColor,
  strokeWidth: '3px',
});

const IconSpinner = ({ rootClassName = null, className = null }) => {
  return (
    <Box
      className={[rootClassName, className].filter(Boolean).join(' ') || undefined}
      component="svg"
      preserveAspectRatio="xMidYMid"
      sx={rootClassName ? undefined : rootSx}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" fill="none" r="12" strokeLinecap="round">
        <animateTransform
          attributeName="transform"
          begin="0s"
          calcMode="linear"
          dur="0.9s"
          keyTimes="0;0.5;1"
          repeatCount="indefinite"
          type="rotate"
          values="0 15 15;180 15 15;720 15 15"
        />
        <animate
          attributeName="stroke-dasharray"
          begin="0s"
          calcMode="linear"
          dur="0.9s"
          keyTimes="0;0.5;1"
          repeatCount="indefinite"
          values="9 56;46 14;9 56"
        />
      </circle>
    </Box>
  );
};

export default IconSpinner;
